/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work out a percent (weight/volume) concentration, or how much solute you need for a target percentage. Enter any two values and leave the one you want to find blank.`)
};

const es_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula una concentración porcentual (peso/volumen), o cuánto soluto necesitas para un porcentaje objetivo. Introduce dos valores cualesquiera y deja en blanco el que quieras calcular.`)
};

const de_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie eine Prozent-(Gewicht/Volumen-)Konzentration oder wie viel gelösten Stoff Sie für einen Zielprozentsatz benötigen. Geben Sie zwei beliebige Werte ein und lassen Sie das gesuchte Feld leer.`)
};

const nl_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken een procentuele (gewicht/volume) concentratie, of hoeveel opgeloste stof je nodig hebt voor een gewenst percentage. Vul twee waarden in en laat het veld dat je wilt berekenen leeg.`)
};

const fr_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déterminez une concentration en pourcentage (poids/volume), ou la quantité de soluté nécessaire pour un pourcentage cible. Entrez deux valeurs et laissez vide celle que vous souhaitez trouver.`)
};

const it_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola una concentrazione percentuale (peso/volume), oppure quanto soluto ti serve per una percentuale target. Inserisci due valori qualsiasi e lascia vuoto quello che vuoi trovare.`)
};

const pt_br2_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule uma concentração percentual (peso/volume), ou quanto soluto você precisa para atingir um percentual alvo. Informe dois valores e deixe em branco o que deseja encontrar.`)
};

const pt_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule uma concentração percentual (massa/volume), ou quanto soluto precisa para uma percentagem pretendida. Introduza quaisquer dois valores e deixe em branco o que pretende calcular.`)
};

const ja_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント (重量/体積) 濃度、または目標パーセントに必要な溶質量を計算します。2つの値を入力し、求めたい項目は空欄のままにしてください。`)
};

const zh_pctsol_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算百分比（重量/体积）浓度，或达到目标百分比所需的溶质量。输入任意两个数值，将要求解的字段留空。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_intro", locale)
	if (locale === "en") return en_pctsol_intro(inputs)
	if (locale === "es") return es_pctsol_intro(inputs)
	if (locale === "de") return de_pctsol_intro(inputs)
	if (locale === "nl") return nl_pctsol_intro(inputs)
	if (locale === "fr") return fr_pctsol_intro(inputs)
	if (locale === "it") return it_pctsol_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_intro(inputs)
	if (locale === "pt") return pt_pctsol_intro(inputs)
	if (locale === "ja") return ja_pctsol_intro(inputs)
	return zh_pctsol_intro(inputs)
};